import { RefObject, useEffect, useCallback } from 'react';

export const useClickOutside = (
  elementRef: RefObject<HTMLElement | null>,
  callback: () => void,
  isOpen: boolean
) => {
  const handleClickOutside = useCallback(
    (e: MouseEvent) => {
      if (
        isOpen &&
        elementRef.current &&
        !elementRef.current.contains(e.target as Node)
      ) {
        callback();
      }
    },
    [elementRef, callback]
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [handleClickOutside]);
};
